<eui-dropdown>
    <button euiButton euiRounded euiIconButton euiBasicButton euiSecondary euiTooltip="{{tooltipText}}" [attr.aria-label]="tooltipText">
        <span euiIcon iconClass="eui-icon eui-icon-more-vertical"></span>
    </button>
    <eui-dropdown-content>
        <ng-content></ng-content>
    </eui-dropdown-content>
</eui-dropdown>
